<template>
  <mf-loading-dialog :loading="loading">
    <base-page-layout title="Resultados da consulta">
      <mf-button label="Voltar" color="marca-0-l40" icon="arrow_back" icon-position="left" text @click="goBack" />
      <v-card class="margin-bottom mt-2">
        <v-card-text>
          <consumer-header :consumer="consumer" :startDate="date" :unitName="unit.name" :products="products" />
          <v-divider class="my-4"></v-divider>
          <span v-if="!hasOfferSchedule">Nenhuma oferta encontrada com os dados informados</span>
          <consumer-offer-schedule v-for="offerSchedule in consumerOfferSchedule" :key="offerSchedule._id" class="mb-12" :offer-schedule="offerSchedule" />
          <div v-if="hasOfferSchedule" class="text-center">
            <v-pagination v-model="page" :length="records"></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import { QUERY_USER_OFFERS } from '../../graphql'
import ConsumerHeader from '../components/ConsumerHeader.vue'
import ConsumerOfferSchedule from '../components/ConsumerOfferSchedule.vue'
import { DateTime } from 'luxon'

export default {
  components: {
    BasePageLayout,
    ConsumerHeader,
    ConsumerOfferSchedule,
  },
  props: {
    consumer: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    unit: {
      type: Object,
      required: true,
    },
    products: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    loading: true,
    consumerOfferSchedule: {},
    page: 1,
    pageSize: 4,
    records: 0,
  }),
  computed: {
    productsSkus() {
      return this.products.map((product) => product.sku)
    },
    hasOfferSchedule() {
      return this.consumerOfferSchedule && this.consumerOfferSchedule.length > 0
    },
    hasNoQueryParam() {
      return typeof this.consumer !== 'object' || typeof this.date !== 'string' || typeof this.unit !== 'object' || typeof this.products !== 'object'
    },
  },
  watch: {
    page() {
      this.getConsumerOffersSchedule()
    },
  },
  mounted() {
    if (this.hasNoQueryParam) {
      this.goBack()
    } else {
      this.getConsumerOffersSchedule()
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'consultar-ofertas-descontos' })
    },
    async getConsumerOffersSchedule() {
      this.loading = true
      try {
        const result = await this.$apollo.query({
          query: QUERY_USER_OFFERS,
          variables: {
            page: this.page,
            pageSize: this.pageSize,
            sort: ['start_date'],
            sortDirection: ['ASC'],
            search: '',
            input: {
              document_no: this.consumer.documentNo,
              skus: this.productsSkus,
              unit_id: this.unit.id_erp,
              start_date: DateTime.fromISO(this.date).startOf('day').toFormat('yyyy-MM-dd HH:mm:ss'),
              end_date: DateTime.fromISO(this.date).endOf('day').toFormat('yyyy-MM-dd HH:mm:ss'),
            },
          },
          fetchPolicy: 'no-cache',
        })

        this.records = Math.ceil(result.data.userOffers.records / this.pageSize)
        this.consumerOfferSchedule = result.data.userOffers.offerSchedules
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.margin-bottom {
  margin-bottom: 74px;
}
</style>
